import { DATES } from 'app/_constants/dates.constant';
import * as angular from 'angular';

class SecondaryProposalDetailsSectionComponentCtrl implements ng.IController {
    proposal: ProposalDto;

    constructor(private DATES: DATES) {}

    $onInit() {}
}

angular.module('app').component('pkpSecondaryProposalDetailsSection', {
    controller: SecondaryProposalDetailsSectionComponentCtrl,
    template:
        require('app/secondary-trading/secondary-proposal-details-section.component.html'),
    bindings: {
        proposal: '<',
        title: '<'
    }
});
